/**
 * Storage fallback: delega à StorageChain (IndexedDB → localStorage → memory).
 */

import type { QueueItem } from '../queue';
import {
  loadQueueOrchestrated,
  saveQueueOrchestrated,
} from './storageOrchestrator';
import { migrateQueueItems, migrateQueueStorageV1ToV2 } from './migrations';
import {
  computeQueueChecksum,
  validateQueueChecksum,
} from '../queueIntegrity';
import { estimateStorageUsage } from './quotaManager';

const CHECKSUM_KEY = 'GOMARKE_QUEUE_CHECKSUM';

export { migrateQueueStorageV1ToV2 };

export async function loadQueueFromStorage(): Promise<QueueItem[]> {
  migrateQueueStorageV1ToV2();
  const items = migrateQueueItems(await loadQueueOrchestrated());
  if (typeof window !== 'undefined') {
    try {
      const expected = window.localStorage.getItem(CHECKSUM_KEY);
      if (expected && items.length > 0 && !validateQueueChecksum(items, expected)) {
        return migrateQueueItems(items);
      }
    } catch {
      // ignore
    }
  }
  void estimateStorageUsage(items);
  return items;
}

export async function saveQueueToStorage(items: QueueItem[]): Promise<void> {
  await saveQueueOrchestrated(items);
  void estimateStorageUsage(items);
  if (typeof window !== 'undefined') {
    try {
      window.localStorage.setItem(CHECKSUM_KEY, computeQueueChecksum(items));
    } catch {
      // quota
    }
  }
}

export function _testSetMemoryQueue(items: QueueItem[]): void {
  void saveQueueToStorage(items);
}
